import clsx from 'clsx';
import React from 'react';

import s from './H.module.less';

type HeadingProps = React.HTMLAttributes<HTMLHeadingElement>;
type DivAttrProps = React.HTMLAttributes<HTMLDivElement>;

export const H1: React.FC<HeadingProps> = ({ className, children, ...rest }) => (
  <h1 className={clsx(s.h1, className)} {...rest}>
    {children}
  </h1>
);

export const H2: React.FC<HeadingProps> = ({ className, children, ...rest }) => (
  <h2 className={clsx(s.h2, className)} {...rest}>
    {children}
  </h2>
);

export const H3: React.FC<HeadingProps> = ({ className, children, ...rest }) => (
  <h3 className={clsx(s.h3, className)} {...rest}>
    {children}
  </h3>
);

export const H4: React.FC<HeadingProps> = ({ className, children, ...rest }) => (
  <h4 className={clsx(s.h4, className)} {...rest}>
    {children}
  </h4>
);

export const PageTitle: React.FC<HeadingProps> = ({ className, children, ...rest }) => (
  <h2 className={clsx(s.pageTitle, className)} {...rest}>
    {children}
  </h2>
);

interface SemiBoldProps extends DivAttrProps {
  capitalize?: boolean;
}

export const SemiBold: React.FC<SemiBoldProps> = ({ capitalize, className, ...rest }) => (
  <div className={clsx(s.semiBold, className, { [s.capitalize]: capitalize })} {...rest} />
);

export const Bold: React.FC<DivAttrProps> = ({ className, ...rest }) => (
  <div className={clsx(s.bold, className)} {...rest} />
);

export const HeadSubTitle: React.FC<DivAttrProps> = ({ className, ...rest }) => (
  <div className={clsx(s.headSubTitle, className)} {...rest} />
);
